import { render } from "./HShippingDetails.vue?vue&type=template&id=6e5f8a3a&ts=true"
import script from "./HShippingDetails.vue?vue&type=script&lang=ts"
export * from "./HShippingDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__